export const confirmModalMessage = string => `<p class="text-[#626262] mb-2">${string}</p>`

export const defaultManagementWorkModeCard = data => {
  const workModeText = {
    WFO: 'WFO (Work From Office)',
    WFH: 'WFH (Work From Home)',
  }

  return `
        <div class="border rounded-lg p-2 flex justify-between text-left mb-2">
            <div>
                <span class="font-semibold block mb-1">Mode Kerja Default Manajemen</span>
                <span style="border: 1px solid #4285F4; background-color: #D9E7FD; color: #376FCB; padding: .25rem .75rem" class="rounded-full">${workModeText[data.work_mode]}</span>
            </div>
            <div>
                <span class="block mb-1">Jam kerja default</span>
                <span style="color: #08A0F7">${data.start_clock} - ${data.end_clock}</span>
            </div>
        </div>
    `
}
